import React from 'react'

export default ({ location, children, data }) =>
<div>
  {children()}
</div>



// WEBPACK FOOTER //
// ./src/layouts/article.js